<template>
  <table border="1" cellspacing="0" class="yaotable">
    <tbody>
      <tr class="tableHead">
        <td>序号</td>
        <td>商品名</td>
        <td>通用名</td>
        <td>厂家</td>
        <td>适应疾病</td>
        <td>指定适应症</td>
      </tr>

      <tr>
        <td>1</td>
        <td>唯可来</td>
        <td>维奈克拉片</td>
        <td>艾伯维</td>
        <td>白血病</td>
        <td>
          本品与阿扎胞苷联合用于治疗因合并症不适合接受强诱导化疗，或者年龄75岁及以上的新诊断的成人急性髓系白血病患者
        </td>
      </tr>

      <tr>
        <td>2</td>
        <td>耐立克</td>
        <td>奥雷巴替尼片</td>
        <td>亚盛医药</td>
        <td>白血病</td>
        <td>
          本品用于任何酪氨酸激酶抑制剂耐药，并采用经充分验证的检测方法诊断为伴有T315I突变的慢性髓细胞白血病慢性期或加速期的成年患者
        </td>
      </tr>

      <tr>
        <td>3</td>
        <td>适加坦</td>
        <td>富马酸吉瑞替尼片</td>
        <td>安斯泰来</td>
        <td>白血病</td>
        <td>
          用于治疗携带FLT3突变的复发性或难治性急性髓系白血病（AML）成人患者。
        </td>
      </tr>

      <tr>
        <td>4</td>
        <td>拓舒沃</td>
        <td>艾伏尼布</td>
        <td>基石药业</td>
        <td>白血病</td>
        <td>
          本品适用于采用经充分验证的检测方法诊断为携带易感异柠檬酸脱氢酶-1（IDH1）突变的复发性或难治性急性髓系白血病（AML）成人患者。
        </td>
      </tr>

      <tr>
        <td>5</td>
        <td>拓益</td>
        <td>特瑞普利单抗注射液</td>
        <td>君实</td>
        <td>鼻咽癌</td>
        <td>
          联合顺铂和吉西他滨用于局部复发或转移性鼻咽癌患者的一线治疗
        </td>
      </tr>

      <tr>
        <td>6</td>
        <td>凯洛斯</td>
        <td>注射用卡非佐米</td>
        <td>百济神州</td>
        <td>多发性骨髓瘤</td>
        <td>
          用于与地塞米松联合适用于治疗复发或难治性（R/R）多发性骨髓瘤（MM）成人患者，患者既往至少接受过2种治疗，包括蛋白酶体抑制剂和免疫调节剂。
        </td>
      </tr>

      <tr>
        <td>7</td>
        <td>法布赞</td>
        <td>注射用阿加糖酶β</td>
        <td>赛诺菲</td>
        <td>法布雷病</td>
        <td>
          本品适用于被确诊为法布雷病( Fabry disease,α-半乳糖苷酶 A
          缺乏)患者的长期酶替代疗法。<br />
          本品适用于成人、8 岁及以上的儿童和青少年
        </td>
      </tr>

      <tr>
        <td>8</td>
        <td>阿美乐</td>
        <td>甲磺酸阿美替尼片</td>
        <td>江苏豪森药业</td>
        <td>肺癌</td>
        <td>
          用于具有表皮生长因子受体外显子19缺失或外显子21（L858R）置换突变的局部晚期或转移性非小细胞肺癌成人患者的一线治疗。
        </td>
      </tr>

      <tr>
        <td>9</td>
        <td>普吉华</td>
        <td>普拉替尼</td>
        <td>基石制药</td>
        <td>肺癌</td>
        <td>
          用于既往接受过含铂化疗的转染重排（RET）基因融合阳性的局部晚期或转移性非小细胞肺癌（NSCLC）成人患者的治疗
        </td>
      </tr>

      <tr>
        <td>10</td>
        <td>英飞凡</td>
        <td>度伐利尤单抗</td>
        <td>阿斯利康</td>
        <td>肺癌</td>
        <td>
          1、本品适用于在接受铂类药物为基础的化疗同步放疗后未出现疾病进展的不可切除、III
          期非小细胞肺癌(NSCLC)患者的治疗。<br />
          2、与依托泊苷联合铂类（卡铂或顺铂）化疗方案联合，用于广泛期小细胞肺癌的一线治疗。
        </td>
      </tr>

      <tr>
        <td>11</td>
        <td>择捷美</td>
        <td>舒格利单抗注射液</td>
        <td>基石药业</td>
        <td>肺癌</td>
        <td>
          适用于联合培美曲塞和卡铂用于表皮生长因子受体（EGFR）基因突变阴性和间变性淋巴瘤激酶（ALK）阴性的转移性非鳞状非小细胞肺癌患者的一线治疗，以及联合紫杉醇和卡铂用于转移性鳞状非小细胞肺癌
          （NSCLC） 患者的一线治疗。
        </td>
      </tr>

      <tr>
        <td>12</td>
        <td>艾弗沙</td>
        <td>伏美替尼</td>
        <td>艾力斯</td>
        <td>肺癌</td>
        <td>
          用于具有表皮生长因子受体(EGFR)外显子19缺失突变(19DEL)或外显子21置换突变(21L858R)的局部晚期或转移性非小细胞肺癌(NSCLC)成人患者的一线治疗
        </td>
      </tr>

      <tr>
        <td>13</td>
        <td>可瑞达</td>
        <td>帕博利珠单抗注射液</td>
        <td>默沙东</td>
        <td>
          肺癌、黑色素瘤、头颈部鳞状细胞癌、结直肠癌
        </td>
        <td>
          1.黑色素瘤<br />
          帕博利珠单抗适用于经一线治疗失败的不可切除或转移性黑色素瘤的治疗。<br />
          2.非小细胞肺癌<br />
          帕博利珠单抗适用于由国家药品监督管理局批准的检测评估为 PD-L1
          肿瘤比例分数（TPS） ≥ 1%
          的表皮生长因子受体（EGFR）基因突变阴性和间变性淋巴瘤激酶（ALK）阴性的局部晚期或转移性非小细胞肺癌一线单药治疗。<br />
          帕博利珠单抗联合培美曲塞和铂类化疗适用于表皮生长因子受体（EGFR）基因突变阴性和间变性淋巴瘤激酶（ALK）阴性的转移性非鳞状非小细胞肺癌（NSCLC）的一线治疗。<br />
          帕博利珠单抗联合卡铂和紫杉醇适用于转移性鳞状非小细胞肺癌（NSCLC）患者的一线治疗。<br />
          3.头颈部鳞状细胞癌<br />
          用于通过充分验证的检测评估肿瘤表达PD-L1（综合阳性评分[CPS]≥20）的转移性或不可切除的复发性头颈部鳞状细胞癌（HNSCC）患者的一线治疗。<br />
          4.单药用于KRAS、NRAS和BRAF基因均为野生型，不可切除或转移性高微卫星不稳定性（MSI-H）或错配修复基因缺陷型（dMMR）结直肠癌（CRC）患者的一线治疗。
        </td>
      </tr>

      <tr>
        <td>14</td>
        <td>芮旎爾</td>
        <td>曲前列尼尔注射液</td>
        <td>兆科药业</td>
        <td>肺动脉高压</td>
        <td>
          本品用于治疗肺动脉高压（PAH，WHO分类 1），以减轻运动引起的相关症状。
        </td>
      </tr>

      <tr>
        <td>15</td>
        <td>泰圣奇</td>
        <td>阿替利珠单抗</td>
        <td>罗氏制药</td>
        <td>肝癌</td>
        <td>
          阿替利珠单抗联合贝伐珠单抗治疗既往未接受过全身系统性治疗的不可切除肝细胞癌患者
        </td>
      </tr>

      <tr>
        <td>16</td>
        <td>思而赞</td>
        <td>注射用伊米苷酶</td>
        <td>赛诺菲</td>
        <td>戈谢病</td>
        <td>
          用于确诊患有导致下列一种或多种病症的Ⅰ型戈谢氏病（Gaucher
          disease）的儿童及成人患者的长期酶替代疗法。（贫血，血小板减少症，骨病，肝肿大，脾肿大）
        </td>
      </tr>

      <tr>
        <td>17</td>
        <td>爱地希</td>
        <td>注射用维迪西妥单抗</td>
        <td>荣昌生物</td>
        <td>尿路上皮癌</td>
        <td>
          用于既往接受过系统化疗且 HER2 表达<br />
          为免疫组化检查结果为 2+ 或 3+ 的局部晚期或转移性尿路上皮癌的患者
        </td>
      </tr>

      <tr>
        <td>18</td>
        <td>赫赛莱</td>
        <td>恩美曲妥珠单抗</td>
        <td>罗氏制药</td>
        <td>乳腺癌</td>
        <td>
          1、赫赛莱单药适用于接受了紫杉烷类联合曲妥珠单抗为基础的新辅助治疗后仍残存侵袭性病灶的HER2阳性早期乳腺癌患者的辅助治疗。<br />
          2、单药治疗接受了紫杉烷类和曲妥珠单抗治疗的HER2阳性、不可切除局部晚期或转移性乳腺癌患者，且患者应具备以下任一情形：既往接受过针对局部晚期或转移性乳腺癌的治疗，或在辅助治疗期间或完成辅助治疗后6个月内出现疾病复发。
        </td>
      </tr>

      <tr>
        <td>19</td>
        <td>多恩达</td>
        <td>
          盐酸米托蒽醌脂质体注射液
        </td>
        <td>石药集团</td>
        <td>淋巴瘤</td>
        <td>
          本品适应于既往至少经过一线标准治疗的复发或难治的外周T细胞淋巴瘤（PTCL）成人患者
        </td>
      </tr>

      <tr>
        <td>20</td>
        <td>爱普盾</td>
        <td>肿瘤电场治疗</td>
        <td>再鼎医药</td>
        <td>脑瘤</td>
        <td>
          适用于22岁及以上经组织病理学或影像学诊断的复发性幕上胶质母细胞瘤（GBM）及新诊断的幕上GBM。其中，新诊断的GBM患者中，在手术治疗与放射治疗后，本产品与替莫唑胺（TMZ）联合使用，在复发性GBM患者中本产品为单一治疗方法
        </td>
      </tr>

      <tr>
        <td>21</td>
        <td>
          人工耳蜗植入体 Cochlear Implant
        </td>
        <td>
          人工耳蜗植入体 Cochlear Implant
        </td>
        <td>科利耳</td>
        <td>
          重度或极重度感音神经性耳聋
        </td>
        <td>
          重度或极重度感音神经性耳聋
        </td>
      </tr>

      <tr>
        <td>22</td>
        <td>海芮思</td>
        <td>艾度硫酸酯酶β注射液</td>
        <td>北海康成</td>
        <td>黏多糖贮积症II型</td>
        <td>
          用于确诊的黏多糖贮积症II型（MPS II，亨特综合征）患者的酶替代治疗。
        </td>
      </tr>

      <tr>
        <td>23</td>
        <td>美而赞</td>
        <td>注射用阿糖甘酶α</td>
        <td>赛诺菲</td>
        <td>庞贝病</td>
        <td>
          注射用阿糖苷酶α是一种溶酶体糖原特异性水解酶，用于庞贝病（酸性α-葡萄糖苷酶[GAA]缺乏症）患者的治疗。
        </td>
      </tr>

      <tr>
        <td>24</td>
        <td>爱博新</td>
        <td>哌柏西利胶囊</td>
        <td>辉瑞</td>
        <td>乳腺癌</td>
        <td>
          本品适用于激素受体(HR)阳性、人表皮生长因子受体 2
          (HER2)阴性的局部晚期或转移性乳腺癌，应与芳香化酶抑制剂联合使用作为绝经后女性患者的初始内分泌治疗
        </td>
      </tr>

      <tr>
        <td>25</td>
        <td>艾瑞康</td>
        <td>羟乙磺酸达尔西利片</td>
        <td>江苏恒瑞</td>
        <td>乳腺癌</td>
        <td>
          联合氟维司群用于激素受体（HR）阳性，人表皮因子受体2（HER2）阴性的经内分泌治疗后进展的复发或转移性乳腺癌的治疗
        </td>
      </tr>

      <tr>
        <td>26</td>
        <td>贝安汀</td>
        <td>贝伐珠单抗注射液</td>
        <td>海正生物制药</td>
        <td>
          上皮性卵巢癌、输卵管癌或原发性腹膜癌、宫颈癌
        </td>
        <td>
          1、上皮性卵巢癌、输卵管癌或原发性腹膜癌<br />
          贝伐珠单抗联合卡铂和紫杉醇用于初次手术切除后的 III 期或 IV
          期上皮性卵巢癌、输卵管癌或原发性腹膜癌患者的一线治疗。<br />
          2、宫颈癌<br />
          贝伐珠单抗联合紫杉醇和顺铂或紫杉醇和托泊替康用于持续性、复发性或转移性宫颈癌患者的治疗。
        </td>
      </tr>

      <tr>
        <td>27</td>
        <td>艾瑞卡</td>
        <td>注射用卡瑞利珠单抗</td>
        <td>江苏恒瑞</td>
        <td>食管癌、鼻咽癌</td>
        <td>
          1、联合紫杉醇和顺铂用于晚期食管癌一线治疗<br />
          2、用于既往接受过二线及以上化疗后疾病进展或不可耐受的晚期鼻咽癌患者的治疗。<br />
          3、本品联合顺铂和吉西他滨用于局部复发或转移性鼻咽癌患者的一线治疗。
        </td>
      </tr>

      <tr>
        <td>28</td>
        <td>擎乐</td>
        <td>瑞派替尼</td>
        <td>再鼎医药</td>
        <td>胃肠道间质瘤</td>
        <td>
          用于已治疗接受过包括伊马替尼在内的3种及以上激酶抑制剂治疗的晚期胃肠道间质瘤（GIST）成人患者。
        </td>
      </tr>

      <tr>
        <td>29</td>
        <td>欧狄沃</td>
        <td>纳武利尤单抗注射液</td>
        <td>百时美施贵宝</td>
        <td>胃或胃食管连接部腺癌</td>
        <td>
          胃腺癌和胃食道连接部腺癌<br />
          本品可用于治疗既往接受过两种或两种以上全身性治疗方案的晚期或复发性胃或胃食管连接部腺癌患者
        </td>
      </tr>

      <tr>
        <td>30</td>
        <td>唯铭赞</td>
        <td>依洛硫酸酯酶</td>
        <td>百傲万里</td>
        <td>IVA 型黏多糖贮积症</td>
        <td>
          本品适用于 IVA 型黏多糖贮积症患者（MPS IVA，Morquio A 综合征）
        </td>
      </tr>

      <tr>
        <td>31</td>
        <td>Daurismo</td>
        <td>Glasdegib/格拉吉布</td>
        <td>辉瑞</td>
        <td>白血病</td>
        <td>
          适用于与低剂量阿糖胞苷联合使用，用于在不能使用强化诱导化疗的 ≥ 75
          岁或患有合并疾病的成年患者中治疗新诊断的急性髓细胞性白血病（AML）。
        </td>
      </tr>

      <tr>
        <td>32</td>
        <td>Onureg</td>
        <td>
          Azacitidine/阿扎胞苷片
        </td>
        <td>施贵宝</td>
        <td>白血病</td>
        <td>
          强化诱导化疗后首次达到完全缓解（CR）或完全缓解伴血细胞计数不完全恢复（CRi）且不能完成强化治愈性治疗的急性髓系白血病（AML）成人患者的持续治疗。
        </td>
      </tr>

      <tr>
        <td>33</td>
        <td>Truseltiq</td>
        <td>
          infigratinib/英菲格拉替尼
        </td>
        <td>联拓生物</td>
        <td>胆管癌</td>
        <td>
          用于成人既往接受过治疗的、不可切除的局部晚期或转移性的伴有成纤维细胞生长因子受体
          2（FGFR2）融合或其他重排（可通过 FDA
          批准的检测方法来检测）的胆管癌患者。
        </td>
      </tr>

      <tr>
        <td>34</td>
        <td>Sarclisa</td>
        <td>
          isatuximab-irfc/赛可益注射液
        </td>
        <td>赛诺菲</td>
        <td>多发性骨髓瘤</td>
        <td>
          1.与泊马度胺和地塞米松联用，治疗既往接受过至少两种治疗（包含来那度胺和一种蛋白酶体抑制剂，并在最后一次治疗中表现出疾病进展）的复发和难治性多发性骨髓瘤成年患者。<br />
          2.与卡非佐米和地塞米松联用，治疗既往接受过至少一种治疗的多发性骨髓瘤成人患者。
        </td>
      </tr>

      <tr>
        <td>35</td>
        <td>Wakix</td>
        <td>Pitolisant/替洛利生</td>
        <td>琅铧医药</td>
        <td>发作性睡病</td>
        <td>
          成人伴或不伴猝倒的发作性睡病。
        </td>
      </tr>

      <tr>
        <td>36</td>
        <td>Lumakras</td>
        <td>Sotorasib/索托雷塞</td>
        <td>百济神州</td>
        <td>肺癌</td>
        <td>
          适用于治疗既往接受过至少1种全身治疗的KRAS
          G12C突变型局部晚期或转移性非小细胞肺癌（NSCLC）成人患者。
        </td>
      </tr>

      <tr>
        <td>37</td>
        <td>Tepmetko</td>
        <td>Tepotinib/特泊替尼</td>
        <td>默克</td>
        <td>肺癌</td>
        <td>
          含MET外显子14跳跃突变的局晚及转移性非小细胞肺癌（NSCLC）一线及后线治疗。
        </td>
      </tr>

      <tr>
        <td>38</td>
        <td>Tabrecta</td>
        <td>
          Capmatinib/卡马替尼片
        </td>
        <td>诺华肿瘤</td>
        <td>肺癌</td>
        <td>
          治疗转移性非小细胞肺癌（NSCLC）成人患者，这些患者的肿瘤突变导致间质-上皮转化（MET）外显子14
          跳跃突变
        </td>
      </tr>

      <tr>
        <td>39</td>
        <td>Braftovi</td>
        <td>Encorafenib/康奈非尼</td>
        <td>皮尔法伯</td>
        <td>黑色素瘤、结直肠癌</td>
        <td>
          1、与binimetinib联合使用，用于治疗患有不可切除性或转移性黑色素瘤伴BRAF
          V600突变的成年患者；<br />
          2、与西妥昔单抗联合使用，用于治疗患有转移性结肠直肠癌（CRC）伴BRAF
          V600E突变，且曾经接受过系统治疗的成人患者。
        </td>
      </tr>

      <tr>
        <td>40</td>
        <td>Tazverik</td>
        <td>
          tazemetostat/他泽司他
        </td>
        <td>和黄医药</td>
        <td>淋巴瘤、上皮样肉瘤</td>
        <td>
          1.
          用于治疗无法完全手术切除的转移性或局部晚期上皮样肉瘤成人及16岁以上儿童患者<br />
          2.
          用于EZH2突变且既往接受过至少2种全身系统治疗的复发性或难治性滤泡性淋巴瘤成人患者的治疗<br />
          3. 用于无合适的可替代治疗方案的复发性或难治性滤泡性淋巴瘤
          成人患者的治疗
        </td>
      </tr>

      <tr>
        <td>41</td>
        <td>Balversa</td>
        <td>
          Erdafitinib/厄达替尼片
        </td>
        <td>西安杨森</td>
        <td>尿路上皮癌</td>
        <td>
          患有局部晚期或转移性尿路上皮癌(metastaticurothelial carcinoma,
          mUC)成年患者的治疗，需要满足：存在FGFR3或FGFR2易感型基因改变，以及既往接受过至少一线含铂化疗且化疗期间或之后出现疾病进展，包括在接受含铂新辅助化疗或辅助化疗后的12个月内出现疾病进展。
        </td>
      </tr>

      <tr>
        <td>42</td>
        <td>Bavencio</td>
        <td>Avelumab/阿维鲁单抗</td>
        <td>默克</td>
        <td>
          尿路上皮癌、肾细胞癌、默克尔细胞癌(MCC)
        </td>
        <td>
          默克氏细胞癌;肾细胞癌;泌尿道上皮细胞癌。
        </td>
      </tr>

      <tr>
        <td>43</td>
        <td>Talzenna</td>
        <td>
          Talazoparib/他拉唑帕尼
        </td>
        <td>辉瑞</td>
        <td>乳腺癌</td>
        <td>
          Talazoparib是一种聚腺苷二磷酸核糖聚合酶 (PARP)
          抑制剂，适用于治疗有害或疑似有害生殖系 BRCA 突变 (gBRCAm) HER2
          阴性局部晚期或转移性乳腺癌成人患者。
        </td>
      </tr>

      <tr>
        <td>44</td>
        <td>Phesgo</td>
        <td>
          Pertuzumab/trastuzumab/Hyaluronidase-zzxf/帕妥珠单抗/曲妥珠单抗/透明质酸酶-zzxf注射剂
        </td>
        <td>罗氏制药</td>
        <td>乳腺癌</td>
        <td>
          早期乳腺癌：<br />
          • 用于 HER2 阳性、局部晚期、炎性或早期乳腺癌患者（直径&gt;2 cm
          或淋巴结阳性）的新辅助治疗，作为早期乳腺癌整体治疗方案的一部分。<br />
          • 用于具有高复发风险 HER2 阳性早期乳腺癌患者的辅助治疗。<br />
          转移性乳腺癌：<br />
          • 本品和多西他赛联合，适用于
          HER2阳性、转移性或不可切除的局部复发性乳腺癌患者。针对转移性疾病，患者既往未接受过抗
          HER2 治疗或者化疗。
        </td>
      </tr>

      <tr>
        <td>45</td>
        <td>Enhertu</td>
        <td>
          Fam-trastuzumab deruxtecan-nxki，DS-8201/曲妥珠单抗重组冻干粉注射剂
        </td>
        <td>阿斯利康</td>
        <td>乳腺癌、胃癌</td>
        <td>
          1.有化疗史、HER2阳性的无法手术或复发性乳腺癌（仅限难以进行标准治疗的情况）。<br />
          2.癌症化疗后恶化的HER2阳性，且无法根治切除的进展/复发的胃癌。
        </td>
      </tr>

      <tr>
        <td>46</td>
        <td>Alkindi</td>
        <td>
          Hydrocortisone/氢化可的松可拆壳胶囊装颗粒剂
        </td>
        <td>琅铧医药</td>
        <td>肾上腺功能不全</td>
        <td>
          婴儿、儿童和青少年（出生至&lt; 18岁）肾上腺功能不全的替代疗法。
        </td>
      </tr>

      <tr>
        <td>47</td>
        <td>Foscan</td>
        <td>Temoporfin/替莫泊芬</td>
        <td>佰礼医药</td>
        <td>头颈部鳞状癌</td>
        <td>
          头颈颌面眼耳鼻喉部恶性肿瘤（鳞癌）。不能手术或不能放疗化疗的恶性肿瘤。
        </td>
      </tr>

      <tr>
        <td>48</td>
        <td>Efmody</td>
        <td>
          hydrocortisone/氢化可的松缓释硬胶囊
        </td>
        <td>琅铧医药</td>
        <td>
          先天性肾上腺皮质增生（CAH）
        </td>
        <td>
          适用于≥12岁的青少年及成人先天性肾上腺皮质增生（CAH）的替代治疗。
        </td>
      </tr>

      <tr>
        <td>49</td>
        <td>VYVGARTTM/卫伟迦</td>
        <td>
          Efgartigimod alfa-fcab/艾加莫德α注射液
        </td>
        <td>再鼎医药</td>
        <td>重症肌无力</td>
        <td>
          适用于治疗乙酰胆碱受体（AChR）抗体阳性的成人全身型重症肌无力患者。
        </td>
      </tr>

      <tr>
        <td>50</td>
        <td>LIVMARLI</td>
        <td>
          Maralixibat/马昔巴特口服液
        </td>
        <td>北海康成</td>
        <td>阿拉杰里综合征</td>
        <td>
          适用于治疗1岁及以上的阿拉杰里综合征（Alagille Syndrome,
          ALGS）患者的胆汁淤积性瘙痒。
        </td>
      </tr>

      <tr>
        <td>51</td>
        <td>奕凯达</td>
        <td>阿基仑赛注射液</td>
        <td>复星凯特生物</td>
        <td>淋巴瘤</td>
        <td>
          用于治疗二线或以上系统性治疗后复发或难治性大B细胞淋巴瘤成人患者，包括弥漫性大B细胞淋巴瘤（DLBCL）非特指型、原发性纵隔B细胞淋巴瘤（PMBCL）、高级别B细胞淋巴瘤和滤泡淋巴瘤转化的DLBCL。
        </td>
      </tr>

      <tr>
        <td>52</td>
        <td>倍诺达</td>
        <td>瑞基奥仑赛注射液</td>
        <td>药明巨诺</td>
        <td>淋巴瘤</td>
        <td>
          经过二线或以上系统性治疗后成人患者的复发或难治性大B细胞淋巴瘤，
          包括弥漫性大B细胞淋巴瘤非特指型、滤泡性淋巴瘤转化的弥漫性大B细
          胞淋巴瘤、3b级滤泡性淋巴瘤、原发纵隔大B细胞淋巴瘤、高级别B细胞
          淋巴瘤伴MYC和BCL-2和/或BCL-6重排(双打击/三打击淋巴瘤)。
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
  import { cdnresources } from '@/util/config'
  export default {
    data() {
      return {
        cdnresources
      }
    }
  }
</script>

<style lang="scss" scoped>
  .yaotable {
    table-layout: fixed;
    border-collapse: collapse;
    width: 100%;
    text-align: center;
    border-color: #ff9695;
    color: #333333;
    font-size: 12px;
    .tableHead {
      height: xvw(100);
      background: #ffeded;
    }
    td {
      p {
        word-break: break-all !important;
        white-space: pre-wrap;
      }
    }
    td:first-child {
      width: 30px;
    }
    td:last-child {
      width: 120px;
    }
  }
</style>
